import React from 'react';
import {
  Navbar,
  NavbarBrand
} from 'reactstrap';
import { useLocation } from 'react-router-dom';

import TranslateMessage from '../common/TranslateMessage/TranslateMessage';

const PublicAppBar = (props) => {
  // const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const isPreview = location.pathname.includes('preview');

  // const toggle = () => setIsOpen(!isOpen);
  const homeUrl = window.location.origin + window.location.pathname + '#/' + `${isPreview ? 'preview' : ''}`;

  return (
    <header>
      <Navbar color="info" dark expand="md">
        <div className="container">
          <NavbarBrand href={homeUrl}>
            <TranslateMessage id="app.logo"/>
          </NavbarBrand>
          {/* <NavbarToggler onClick={toggle} /> */}
          {/* <Collapse isOpen={isOpen} navbar> */}
          {/*  <Nav className="mr-auto" navbar> */}
          {/*  </Nav> */}
          {/* </Collapse> */}
        </div>
      </Navbar>
    </header>
  );
};

export default PublicAppBar;
